import { addDoc, collection, getDocs } from "@firebase/firestore"
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { hideLoading, setItemCategoriesList, setItemStatusList, setItemTypesList, showLoading } from "./items-add-slice";
import { addItems } from "../items-list/items-list-slice";

const calculateSalePrice = async (dispatch, original_price, increase) => {
    try {
        if (original_price > 0 && increase > 0) {
            const increaseAmount = original_price * (increase / 100);
            const sellingPrice = parseFloat(original_price) + increaseAmount;
            const sellingPriceRounded = Math.round(sellingPrice);
            return sellingPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating selling price.'))
        console.error("ItemsAdd calculateSalePrice error: ", e);
    }
};

const calculateRentPrice = async (dispatch, original_price, rent_percent) => {
    try {
        if (original_price > 0 && rent_percent > 0) {
            const increaseAmount = original_price * (rent_percent / 100);
            const rentingPriceRounded = Math.round(increaseAmount);
            return rentingPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating rental price.'))
        console.error("ItemsAdd calculateRentPrice error: ", e);
    }
};

const calculateDepositPrice = async (dispatch, original_price, deposit_percent) => {
    try {
        if (original_price > 0 && deposit_percent > 0) {
            const increaseAmount = original_price * (deposit_percent / 100);
            const depositPriceRounded = Math.round(increaseAmount);
            return depositPriceRounded;
        }
    } catch(e) {
        dispatch(showErrorSnackbar('Something went wrong when calculating deposit price.'))
        console.error("ItemsAdd calculateDepositPrice error: ", e);
    }
};

export const addItemsService = async (dispatch, db, coll, formData) => {
    dispatch(showLoading());
    try {
        if (formData.type === "For sale") {
            const calculatedUnitPrice = await calculateSalePrice(dispatch, formData.original_price, formData.increase);
            const new_data = {
                ...formData,
                unit_price: calculatedUnitPrice,
            };
            const docRef = await addDoc(collection(db, coll), new_data);
            dispatch(addItems({
                id: docRef.id,
                ...new_data
            }));
        } else {
            const calculatedRentPrice = await calculateRentPrice(dispatch, formData.original_price, formData.rent_percent);
            const calculatedDepositPrice = await calculateDepositPrice(dispatch, formData.original_price, formData.deposit_percent);
            const new_data = {
                ...formData,
                rent_price: calculatedRentPrice,
                deposit: calculatedDepositPrice
            };
            const docRef = await addDoc(collection(db, coll), new_data);
            dispatch(addItems({
                id: docRef.id,
                ...new_data
            }));
        }
        dispatch(showSuccessSnackbar('Added successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Add failed! Please try again.'));
        console.error("ItemsAdd addItemsService error: ", e);
    }
    dispatch(hideLoading());
};

export const getItemTypesListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemTypesList(data));
        });
    } catch(e) {
        console.error("ItemsAdd getItemTypesService error: ", e);
    }
};

export const getItemStatusListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemStatusList(data));
        });
    } catch(e) {
        console.error("ItemsAdd getItemStatusListService error: ", e);
    }
};

export const getItemCategoriesListService = async (dispatch, db, coll) => {
    try {
        await getDocs(collection(db, coll))
        .then((querySnapshot) => {
            const data = querySnapshot.docs
                .map((doc) => ({...doc.data(), id:doc.id}));
            dispatch(setItemCategoriesList(data));
        });
    } catch(e) {
        console.error("ItemsAdd getItemCategoriesListService error: ", e);
    }
};